module.exports = __webpack_public_path__ + "img/default_default.cf7541d2.png";